import { render } from "./StudiesList.vue?vue&type=template&id=ad46c2be"
import script from "./StudiesList.vue?vue&type=script&lang=js"
export * from "./StudiesList.vue?vue&type=script&lang=js"
script.render = render

export default script